import { format } from 'date-fns';

export function safeFormatDate(date: unknown, formatString = 'PPP'): string {
  if (!date) return 'Not specified';

  try {
    const dateObj = typeof date === 'string' ? new Date(date) : (date as Date);
    if (isNaN(dateObj.getTime())) return 'Invalid date';
    return format(dateObj, formatString);
  } catch {
    return 'Invalid date';
  }
}
